// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b7SQCiyFPZqc1uaAvCXR {
  display: flex;
  flex-direction: column;
}

.swjjQWaG5Dq7Gk5RJ89w {
  margin-bottom: 3rem;
}

@media only screen and
  (max-width: 639px) {
  .b7SQCiyFPZqc1uaAvCXR {
    margin-bottom: 1rem;
  }

  .swjjQWaG5Dq7Gk5RJ89w {
    margin-bottom: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchTerms/SearchTerms.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".searchTerms {\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  margin-bottom: 48px;\n}\n\n@media (--mobile) {\n  .searchTerms {\n    margin-bottom: 16px;\n  }\n\n  .title {\n    margin-bottom: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchTerms": `b7SQCiyFPZqc1uaAvCXR`,
	"title": `swjjQWaG5Dq7Gk5RJ89w`
};
export default ___CSS_LOADER_EXPORT___;
